<template>
  <div>
    <div class="content_s">
      <div v-if="Type == 'is_consume'">
        <el-radio-group v-model="form.consume_type" @change="radio">
          <el-radio :label="1">每笔订单一次</el-radio>
          <el-radio :label="2">每笔订单多次</el-radio>
        </el-radio-group>
      </div>
      <div v-if="Type == 'is_consume_card_recharge'">
        <el-radio-group
          v-model="form.consume_card_recharge_type"
          @change="radio"
        >
          <el-radio :label="1">每笔订单一次</el-radio>
          <el-radio :label="2">每笔订单多次</el-radio>
        </el-radio-group>
      </div>
      <div v-if="Type == 'is_consume_card_consume'">
        <el-radio-group
          v-model="form.consume_card_consume_type"
          @change="radio"
        >
          <el-radio :label="1">每笔订单一次</el-radio>
          <el-radio :label="2">每笔订单多次</el-radio>
        </el-radio-group>
      </div>
      <div v-if="Type == 'is_consume'">
        <div v-for="(item, idx) in form.consume_products" :key="idx">
          消费
          <el-select
            v-model="item.goods_ids"
            multiple
            collapse-tags
            size="small"
            style="margin-right: 10px;"
            placeholder="请选择"
          >
            <el-option
              v-for="items in goodsLists"
              :key="items.id"
              :label="items.name"
              :value="items.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="item.quota_type"
            placeholder="请选择"
            size="small"
            style="margin-right: 10px;"
          >
            <el-option label="原价" :value="1"> </el-option>
            <el-option label="实付" :value="2"> </el-option>
            <el-option label="数量" :value="3"> </el-option>
          </el-select>
          <span>每</span>
          <el-input-number size="small" v-model="item.quota"></el-input-number>
          <span v-if="item.quota_type == 1 || item.quota_type == 2">元</span>
          <span v-else-if="item.quota_type == 3">升</span>
          <span
            >获得抽奖
            <el-input
              placeholder="整数"
              v-model="item.num"
              type="number"
              class="no-number"
              style="width: 10%;"
            ></el-input>
            次</span
          >
          <el-button
            type="text"
            @click="add('is_consume')"
            style="margin-left: 10px;"
            >添加</el-button
          >
          <el-button
            type="text"
            @click="del(idx, 'is_consume')"
            v-if="form.consume_products.length > 1"
            >删除</el-button
          >
        </div>
      </div>
      <div v-if="Type == 'is_consume_card_recharge'">
        <div v-for="(item, idx) in form.consume_card_recharge_cards" :key="idx">
          消费
          <el-select
            v-model="item.goods_ids"
            multiple
            collapse-tags
            size="small"
            style="margin-right: 10px;"
            placeholder="请选择"
          >
            <el-option
              v-for="items in listRefuleList"
              :key="items.id"
              :label="items.name"
              :value="items.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="item.quota_type"
            placeholder="请选择"
            size="small"
            style="margin-right: 10px;"
          >
            <el-option label="原价" :value="1"> </el-option>
          </el-select>
          <span>每</span>
          <el-input-number size="small" v-model="item.quota"></el-input-number>
          <span v-if="item.quota_type == 1 || item.quota_type == 2">元</span>
          <span v-else-if="item.quota_type == 3">升</span>
          <span
            >获得抽奖
            <el-input
              placeholder="整数"
              v-model="item.num"
              type="number"
              class="no-number"
              style="width: 10%;"
            ></el-input>
            次</span
          >
          <el-button
            type="text"
            @click="add('is_consume_card_recharge')"
            style="margin-left: 10px;"
            >添加</el-button
          >
          <el-button
            type="text"
            @click="del(idx, 'is_consume_card_recharge')"
            v-if="form.consume_card_recharge_cards.length > 1"
            >删除</el-button
          >
        </div>
      </div>
      <div v-if="Type == 'is_consume_card_consume'">
        <div v-for="(item, idx) in form.consume_card_consume_cards" :key="idx">
          消费
          <el-select
            v-model="item.goods_ids"
            multiple
            collapse-tags
            size="small"
            style="margin-right: 10px;"
            placeholder="请选择"
          >
            <el-option
              v-for="items in listRefuleList"
              :key="items.id"
              :label="items.name"
              :value="items.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="item.quota_type"
            placeholder="请选择"
            size="small"
            style="margin-right: 10px;"
          >
            <el-option label="原价" :value="1"> </el-option>
            <el-option label="实付" :value="2"> </el-option>
          </el-select>
          <span>每</span>
          <el-input-number size="small" v-model="item.quota"></el-input-number>
          <span v-if="item.quota_type == 1 || item.quota_type == 2">元</span>
          <span v-else-if="item.quota_type == 3">升</span>
          <span
            >获得抽奖
            <el-input
              placeholder="整数"
              v-model="item.num"
              type="number"
              class="no-number"
              style="width: 10%;"
            ></el-input>
            次</span
          >
          <el-button
            type="text"
            @click="add('is_consume_card_consume')"
            style="margin-left: 10px;"
            >添加</el-button
          >
          <el-button
            type="text"
            @click="del(idx, 'is_consume_card_consume')"
            v-if="form.consume_card_consume_cards.length > 1"
            >删除</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store/index";
import { goodsList, listRefule } from "@/api/vip";

export default {
  props: {
    Type: {
      type: String,
    },
    Status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {},
      switchStatusData: this.Status,
      listRefuleList: [],
      goodsLists: [],
    };
  },

  mounted() {
    this.form = store.getters.lotteryfrom;
    console.log("9999", this.form);
    if (this.form.consume_products.length == 0)
      this.form.consume_products = [
        {
          goods_ids: "",
          quota_type: 1,
          quota: 0,
          num: 0,
        },
      ];
    if (this.form.consume_card_recharge_cards.length == 0)
      this.form.consume_card_recharge_cards = [
        {
          goods_ids: "",
          quota_type: 1,
          quota: 0,
          num: 0,
        },
      ];
    if (this.form.consume_card_consume_cards.length == 0)
      this.form.consume_card_consume_cards = [
        {
          goods_ids: "",
          quota_type: 1,
          quota: 0,
          num: 0,
        },
      ];
    if (this.$route.query.key == 1) {
      this.form.consume_products.forEach((item, i) => {
        if (item.goods_ids.length > 0) {
          item.goods_ids.forEach((e, idx) => {
            item.goods_ids[idx] = Number(e);
          });
        }
      });

      this.form.consume_card_recharge_cards.forEach((item, i) => {
        if (item.goods_ids.length > 0) {
          item.goods_ids.forEach((e, idx) => {
            item.goods_ids[idx] = Number(e);
          });
        }
      });
      this.form.consume_card_consume_cards.forEach((item, i) => {
        if (item.goods_ids.length > 0) {
          item.goods_ids.forEach((e, idx) => {
            item.goods_ids[idx] = Number(e);
          });
        }
      });
    }

    this.get_listRefuleList();
    this.get_goodList();
  },

  watch: {},
  methods: {
    add(type) {
      // debugger
      var obj = {
        goods_ids: [],
        quota_type: 1,
        quota: 0,
        num: 0,
      };
      switch (type) {
        case "is_consume": //消费(非消费卡)
          if (this.form.consume_products.length > 7)
            return this.$message.error("最多添加8个");

          this.form.consume_products.push(obj);
          console.log("is_consume");
          break;
        case "is_consume_card_recharge": //充值
          if (this.form.consume_card_recharge_cards.length > 7)
            return this.$message.error("最多添加8个");

          this.form.consume_card_recharge_cards.push(obj);
          console.log("is_consume_card_recharge");
          break;
        case "is_consume_card_consume": //消费卡
          if (this.form.consume_card_consume_cards.length > 7)
            return this.$message.error("最多添加8个");

          this.form.consume_card_consume_cards.push(obj);
          console.log("is_consume_card_consume");
          break;
        default:
          break;
      }
    },
    del(i, type) {
      switch (this.Type) {
        case "is_consume": //消费(非消费卡)
          if (i === 0) return this.$message("至少保留一个");
          this.form.consume_products.splice(i, 1);
          console.log("is_consume");
          break;
        case "is_consume_card_recharge": //充值
          if (i === 0) return this.$message("至少保留一个");
          this.form.consume_card_recharge_cards.splice(i, 1);
          console.log("is_consume_card_recharge");
          break;
        case "is_consume_card_consume": //消费卡
          if (i === 0) return this.$message("至少保留一个");
          this.form.consume_card_consume_cards.splice(i, 1);
          console.log("is_consume_card_consume");
          break;
        default:
          break;
      }
    },
    radio(val) {
      switch (this.Type) {
        case "is_consume": //消费(非消费卡)
          store.getters.lotteryfrom.consume_type = val;
          console.log("is_consume");
          break;
        case "is_consume_card_recharge": //充值
          store.getters.lotteryfrom.consume_card_recharge_type = val;
          console.log("is_consume_card_recharge");
          break;
        case "is_consume_card_consume": //消费卡
          store.getters.lotteryfrom.consume_card_consume_type = val;
          console.log("is_consume_card_consume");
          break;
        default:
          break;
      }
    },
    async get_listRefuleList() {
      const res = await listRefule({
        app_id: store.getters.app_id,
      });
      if (res.code == 200) {
        this.listRefuleList = res.result;
        console.log(res);
      }
    },
    async get_goodList() {
      const res = await goodsList({
        app_id: store.getters.app_id,
      });
      if (res.code == 200) {
        this.goodsLists = res.data;
        console.log(res);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content_s {
  width: 70%;
  background-color: #f8f8f8;
  padding: 1vw;
  margin-left: 10px;
}
</style>
